export const experienceData = [
    {
    id: 1,
    company: "Ministry of National Health Services Regulations and Coordination, Government of Pakistan",
    jobtitle: "Software Engineer / Infrastructure Engineer",
    startYear: "Jan 2026",
    endYear: " Present",
  },
  {
    id: 2,
    company: "ShopnPay (Self-Employed)",
    jobtitle: "CEO / Full-Stack Mobile Application Developer",
    startYear: "Sep 2023 ",
    endYear: " Present",
  },
  {
    id: 3 ,
    company: "HBL Microfinance Bank (IT Department), Islamabad",
    jobtitle:
      "Robotic Process Automation Engineer / Mobile Application Developer",
    startYear: "Aug 2024 ",
    endYear: " Mar 2025",
  },
  {
    id: 4,
    company: "Freelancing, Upwork",
    jobtitle: "Full-Stack Mobile Application Developer",
    startYear: "Sep 2023 ",
    endYear: " Present",
  },
  {
    id: 5,
    company: "Bahria International Hospital, Rawalpindi",
    jobtitle: "Front-End Web Developer",
    startYear: "Jan 2023 ",
    endYear: " Feb 2023",
  },
  {
    id: 6,
    company: "Anjuman Faiz-ul-Islam, Rawalpindi",
    jobtitle: "Website Analyst, Web Developer",
    startYear: "Jan 2023 ",
    endYear: " Feb 2023",
  },
];
